class ProductShare extends window.HTMLElement {
  constructor() {
    super();
    this.shareUrl = this.getAttribute("share-url") || window.location.href;
    this.shareTitle = this.getAttribute("share-title") || document.title;
    this.shareButton = null;
    this.shareMenu = null;
  }
  connectedCallback() {
    this.shareButton = this.querySelector("[data-share-button]");
    this.shareMenu = this.querySelector("[data-share-menu]");
    if (!this.shareButton || !this.shareMenu) {
      console.error("product-share requires [data-share-button] and [data-share-menu] elements");
      return;
    }
    this.shareButton.addEventListener("click", this.toggleShareMenu.bind(this));
    document.addEventListener("click", this.handleOutsideClick.bind(this));
    this.attachShareListeners();
  }
  disconnectedCallback() {
    document.removeEventListener("click", this.handleOutsideClick.bind(this));
  }
  toggleShareMenu(e) {
    e.preventDefault();
    e.stopPropagation();
    const isOpen = this.shareMenu.classList.contains("active");
    if (isOpen) {
      this.closeShareMenu();
    } else {
      this.openShareMenu();
    }
  }
  openShareMenu() {
    this.shareMenu.classList.add("active");
    this.setAttribute("aria-expanded", "true");
  }
  closeShareMenu() {
    this.shareMenu.classList.remove("active");
    this.setAttribute("aria-expanded", "false");
  }
  handleOutsideClick(e) {
    if (!this.contains(e.target)) {
      this.closeShareMenu();
    }
  }
  attachShareListeners() {
    const shareLinks = this.querySelectorAll("[data-share-platform]");
    shareLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const platform = link.getAttribute("data-share-platform");
        this.share(platform);
        this.closeShareMenu();
      });
    });
    const copyButton = this.querySelector("[data-copy-link]");
    if (copyButton) {
      copyButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.copyToClipboard();
        this.closeShareMenu();
      });
    }
  }
  share(platform) {
    const url = encodeURIComponent(this.shareUrl);
    const title = encodeURIComponent(this.shareTitle);
    const shareUrls = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      twitter: `https://twitter.com/intent/tweet?url=${url}&text=${title}`,
      pinterest: `https://pinterest.com/pin/create/button/?url=${url}&description=${title}`,
      email: `mailto:?subject=${title}&body=${url}`,
      whatsapp: `https://wa.me/?text=${title}%20${url}`
    };
    const shareUrl = shareUrls[platform];
    if (shareUrl) {
      const width = 600;
      const height = 400;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;
      window.open(
        shareUrl,
        "share",
        `width=${width},height=${height},left=${left},top=${top}`
      );
    }
  }
  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.shareUrl);
      const copyButton = this.querySelector("[data-copy-link]");
      if (copyButton) {
        const originalText = copyButton.querySelector("span")?.textContent;
        const textElement = copyButton.querySelector("span");
        if (textElement) {
          textElement.textContent = "Copied!";
          setTimeout(() => {
            textElement.textContent = originalText;
          }, 2e3);
        }
      }
    } catch (error) {
      console.error("Failed to copy link:", error);
    }
  }
}
window.customElements.define("product-share", ProductShare);
export {
  ProductShare as default
};
